package com.appcreator.blueprint.actions

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.Condition
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("Condition")
@ActionClass(
    group = "Logic",
    title = "Conditional Action",
    availableFrom = "0.0.1"
)
class ConditionAction(
    @InputProperty(
        title = "Condition",
        availableFrom = "0.0.1"
    )
    val condition: Condition?,
    @InputProperty(
        title = "Success Action",
        availableFrom = "0.0.1"
    )
    val successAction: Action?,
    @InputProperty(
        title = "Failure Action",
        availableFrom = "0.0.1"
    )
    val failureAction: Action?,
): Action
